// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const VideoClip_Stroke1_Corner0_Rounded = createSinglePathSVG({
  path: 'm15.416 9.876-4.5-3A.75.75 0 0 0 9.75 7.5v6a.75.75 0 0 0 1.166.624l4.5-3a.75.75 0 0 0 0-1.248Zm-4.166 2.222V8.906l2.398 1.594Zm9-8.348H3.75a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5Zm0 12H3.75V5.25h16.5v10.5Zm1.5 3.75a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h18a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'VideoClip_Stroke1_Corner0_Rounded',
})

export const VideoClip_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M23.603 6.844a.75.75 0 0 0-.77.036L19.5 9.098V6.75a1.5 1.5 0 0 0-1.5-1.5H3a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-2.344l3.334 2.223a.75.75 0 0 0 .416.121.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.397-.656ZM18 17.25H3V6.75h15v10.5Zm4.5-2.152-3-2v-2.197l3-1.995Z',
  viewBox: '0 0 24 24',
  glyph: 'VideoClip_Stroke2_Corner0_Rounded',
})
